import { WorkspaceEntity } from 'modules/Workspaces/WorkspacesDropdown/utils';

export const getDirectSubWorkspaceCount = (workspaces: Record<string, WorkspaceEntity>, workspaceId: string): number =>
  workspaces[workspaceId]?.childWorkspaces.length ?? 0;
